import React from "react";
import faqs from "../../assets/data/faqs.json";
import Accordion from "react-bootstrap/Accordion";

const FaqSection = ({
  type = "homePage",
  heading = "Frequently Asked Questions",
  subText = "",
}) => {
  const faqData = faqs[type] || [];

  return (
    <section className="faq-section">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-12 col-xl-12 mx-auto">
            <div className="section-heading">
              <h2>{heading}</h2>
            </div>

            <Accordion defaultActiveKey="0">
              {faqData.map((faq, index) => (
                <Accordion.Item
                  key={index}
                  eventKey={`${index}`}
                  className="faq-card"
                >
                  <h3 className="accordion-header">
                    <Accordion.Header as="div">{faq.question}</Accordion.Header>
                  </h3>
                  <Accordion.Body>
                    <div className="faq-info">{faq.answer}</div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>

            {subText && (
              <div className="faq-footer-text mt-4 text-center fw-bold">
                <p>"{subText}"</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
